<div class="accordionbox teaser" *ngIf="data">
    <header *ngIf="data.headline || data.copytext">
        <h2 *ngIf="data.headline" [innerHTML]="data.headline | superscripe"></h2>
        <div class="large" *ngIf="data.copytext && data.copytext.value" [innerHTML]="data.copytext.value | superscripe"></div>
    </header>
    <div class="accordionitems">
        <div class="accordion" *ngFor="let _accordionItem of data.itemList; let i = index">
            <header #accordion class="accordion-header" (click)="toggle(i, _accordionItem.headline)">
                <div class="left">
                    <h3 [innerHTML]="_accordionItem.headline | superscripe"></h3>
                </div>
                <div class="right">
                    <span class="toggleaccordion"></span>
                </div>
            </header>
            <div class="accordion-panel">
                <div class="large" *ngIf="!hasMedia(i)" [innerHtml]="_accordionItem.copytext.value | superscripe"></div>
                <p *ngIf="!hasMedia(i) && _accordionItem.button && _accordionItem.button.url.imageUrl">
                    <a
                        da-button
                        [icon]="_accordionItem.button.text ? '' : 'drg-icon-arrow_level_down'"
                        [link]="_accordionItem.button && _accordionItem.button.url.imageUrl"
                        [themeType]="_accordionItem.button.url.linkType === 'document' ? 'Primary' : 'Secondary'"
                        [innerHTML]="_accordionItem.button.text"
                    ></a>
                </p>
                <div class="accordiomediabox" *ngIf="hasMedia(i)" [class.mediaright]="_accordionItem.mediaAlignment === 'right'">
                    <div class="media" *ngIf="_accordionItem.mediaType === 'image'">
                        <figure>
                            <da-progressive-image
                                [options]="{
                                    alt: _accordionItem.image.altText || _accordionItem.headline,
                                    aspectRatios: [
                                        {
                                            breakpoint: 360,
                                            width: 480,
                                            height: 360,
                                            akamaiImage: getImageUrl(i) | imageUrl
                                        },
                                        {
                                            breakpoint: 480,
                                            width: 768,
                                            height: 576,
                                            akamaiImage: getImageUrl(i) | imageUrl
                                        },
                                        {
                                            breakpoint: 768,
                                            width: 480,
                                            height: 360,
                                            akamaiImage: getImageUrl(i) | imageUrl
                                        },
                                        {
                                            breakpoint: 1120,
                                            width: 768,
                                            height: 576,
                                            akamaiImage: getImageUrl(i) | imageUrl
                                        }
                                    ]
                                }"
                            ></da-progressive-image>
                        </figure>
                    </div>
                    <div class="media" *ngIf="_accordionItem.mediaType === 'video'">
                        <da-video
                            [data]="getImageUrl(i)"
                            [options]="{
                                overlay: true,
                                posterUrl: _accordionItem.video.$urlPosterTarget,
                                altText: _accordionItem.video.altText,
                                posterAltText: _accordionItem.video.altPosterText,
                                aspectRatios: videoImageAspectRatios
                            }"
                        ></da-video>
                    </div>
                    <div
                        class="copy"
                        *ngIf="_accordionItem.copytext.value || (_accordionItem.button && _accordionItem.button.url.imageUrl)"
                    >
                        <div [outerHTML]="_accordionItem.copytext.value | superscripe"></div>
                        <p *ngIf="_accordionItem.button && _accordionItem.button.url.imageUrl">
                            <a
                                da-button
                                [icon]="_accordionItem.button.text ? '' : 'drg-icon-arrow_level_down'"
                                [link]="_accordionItem.button.url.imageUrl"
                                [themeType]="_accordionItem.button.url.linkType === 'document' ? 'Primary' : 'Secondary'"
                                [innerHTML]="_accordionItem.button.text"
                            ></a>
                        </p>
                        <ul class="linklistitems reset" *ngIf="_accordionItem.itemList && _accordionItem.itemList.length > 0">
                            <li *ngFor="let _linkListItem of _accordionItem.itemList; let i = index">
                                <ng-container *ngIf="_linkListItem.button && _linkListItem.button.url.imageUrl">
                                    <a
                                        da-link
                                        [link]="_linkListItem.button.url.imageUrl"
                                        icon="{{ getClassByLinkType(_linkListItem.button.url.imageUrl) }}"
                                        >{{ _linkListItem.button.text | superscripe }}</a
                                    >
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="linkistbox teaser" *ngIf="!hasMedia(i) && _accordionItem.itemList && _accordionItem.itemList.length > 0">
                    <ul class="linklistitems reset">
                        <li *ngFor="let _linkListItem of _accordionItem.itemList; let i = index">
                            <ng-container *ngIf="_linkListItem.button && _linkListItem.button.text && _linkListItem.button.url.imageUrl">
                                <a
                                    da-link
                                    [link]="_linkListItem.button.url.imageUrl"
                                    icon="{{ getClassByLinkType(_linkListItem.button.url.imageUrl) }}"
                                    >{{ _linkListItem.button.text | superscripe }}</a
                                >
                            </ng-container>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
